import React from 'react';
import styled from 'styled-components';

import { WelcomePage } from './welcome.page';
import { ChooseWorkspacePage } from './choose-workspace.page';
import { OnBoardingLayout } from './on-boarding.layout';
import { OnboardingStepsIndicator } from './components/onboarding-steps-indicator';
import { StatsPage } from './stats.page';
import { UpdateProfilePage } from './update-profile.page';
import { CreateWorkspacePage } from './create-workspace.page';

export const OnBoardingPage: React.FC = () => {

  return (
    <OnBoardingLayout>
      <Container>
        <CreateWorkspacePage />
      </Container>
    </OnBoardingLayout>
  );
};

const Container = styled.div`
  max-width: 37rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3.2rem;
`;
